import Vue from 'vue';
import VueI18n from 'vue-i18n';
import config from '../configs';
var _config$locales = config.locales,
  locale = _config$locales.locale,
  availableLocales = _config$locales.availableLocales,
  fallbackLocale = _config$locales.fallbackLocale;

/**
 * Vue Translations
 * https://kazupon.github.io/vue-i18n/
 */
Vue.use(VueI18n);
var messages = {};
availableLocales.forEach(function (l) {
  messages[l.code] = l.messages;
});
export var i18n = new VueI18n({
  locale: locale,
  fallbackLocale: fallbackLocale,
  messages: messages
});
i18n.locales = availableLocales;
export default i18n;